import { render, staticRenderFns } from "./TileButton.vue?vue&type=template&id=8f4cf7c8&scoped=true&"
import script from "./TileButton.vue?vue&type=script&lang=js&"
export * from "./TileButton.vue?vue&type=script&lang=js&"
import style0 from "./TileButton.vue?vue&type=style&index=0&id=8f4cf7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4cf7c8",
  null
  
)

export default component.exports